import { render, staticRenderFns } from "./ButtonV2.vue?vue&type=template&id=4deec7ea&"
import script from "./ButtonV2.vue?vue&type=script&lang=js&"
export * from "./ButtonV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports